var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20491_69805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00191 0.666687H7.99825C3.95483 0.666687 0.666748 3.95569 0.666748 8.00002C0.666748 9.60419 1.18375 11.091 2.06283 12.2983L1.14891 15.0226L3.96766 14.1215C5.12725 14.8897 6.5105 15.3334 8.00191 15.3334C12.0453 15.3334 15.3334 12.0434 15.3334 8.00002C15.3334 3.9566 12.0453 0.666687 8.00191 0.666687Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2688 11.0223C12.0919 11.5218 11.3898 11.9362 10.8297 12.0572C10.4465 12.1388 9.94601 12.2038 8.26117 11.5053C6.10609 10.6125 4.71826 8.42259 4.61009 8.2805C4.50651 8.13842 3.73926 7.12092 3.73926 6.06859C3.73926 5.01625 4.27367 4.50384 4.48909 4.28384C4.66601 4.10325 4.95842 4.02075 5.23892 4.02075C5.32967 4.02075 5.41126 4.02534 5.48459 4.029C5.70001 4.03817 5.80817 4.051 5.95026 4.39109C6.12717 4.81734 6.55801 5.86967 6.60934 5.97784C6.66159 6.086 6.71384 6.23267 6.64051 6.37475C6.57176 6.52142 6.51126 6.5865 6.40309 6.71117C6.29492 6.83584 6.19226 6.93117 6.08409 7.065C5.98509 7.18142 5.87326 7.30609 5.99792 7.5215C6.12259 7.73234 6.55342 8.43542 7.18776 9.00009C8.00634 9.72884 8.67001 9.96167 8.90742 10.0607C9.08434 10.134 9.29517 10.1166 9.42442 9.97909C9.58851 9.80217 9.79109 9.50884 9.99734 9.22009C10.144 9.01292 10.3292 8.98725 10.5235 9.06059C10.7215 9.12934 11.7693 9.64725 11.9847 9.7545C12.2001 9.86267 12.3422 9.914 12.3944 10.0048C12.4458 10.0955 12.4458 10.5218 12.2688 11.0223Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20491_69805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.5ac037551eff96d8b7034267c0b40bd6.svg";
export { ForwardRef as ReactComponent };